"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGridColumns = void 0;
const currency_label_1 = require("@components/currency-label");
const button_1 = require("@shared-modules/components/button");
const expandable_grid_1 = require("@shared-modules/components/expandable-grid");
const number_1 = require("@utils/object/number");
const react_1 = __importDefault(require("react"));
const getGridColumns = (claimBonusesHandler, translator) => [
    {
        id: "token",
        title: translator("claimGridTokenColumnLabel"),
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: (item) => react_1.default.createElement(currency_label_1.CurrencyLabel, { tokenAddress: item.token.address }),
    },
    {
        id: "deals",
        title: translator("claimGridDealsColumnLabel"),
        size: 1,
        type: expandable_grid_1.ItemTypes.Number,
        render: (item) => item.paymentsTotal.toFixed(0),
    },
    {
        id: "earned",
        title: translator("claimGridTotalEarnedColumnLabel"),
        size: 1,
        type: expandable_grid_1.ItemTypes.Number,
        render: (item) => (0, number_1.formatAndNormalizeToken)(item.token, item.totalEarned, item.token.decimals),
    },
    {
        id: "claim",
        title: translator("claimGridReadyToClaimColumnLabel"),
        size: 1,
        type: expandable_grid_1.ItemTypes.Number,
        render: (item) => (0, number_1.formatAndNormalizeToken)(item.token, item.availableToClaim, item.token.decimals),
    },
    {
        id: "control",
        title: "",
        size: "100px",
        type: expandable_grid_1.ItemTypes.Number,
        render: (item) => (react_1.default.createElement(button_1.Button, { disabled: item.availableToClaim.isZero(), onClick: () => claimBonusesHandler(item.token), size: "small" }, translator("claimGridClaimButton"))),
    },
];
exports.getGridColumns = getGridColumns;
